import ExpertiseCard from 'entities/ExpertiseCard';

import { DEFAULT_BORDER, DEFAULT_BORDER_RADIUS } from 'constants/global';

import Layers1 from 'assets/icons/layers1_1.svg';
import Layers2 from 'assets/icons/layers1_2.svg';
import Layers3 from 'assets/icons/layers1_3.svg';
import Layers4 from 'assets/icons/layers1_4.svg';
import Notes from 'assets/icons/notes.svg';
import Architer from 'assets/icons/architer.svg';
import Measuring from 'assets/icons/Measuring.svg';
import Adding from 'assets/icons/adding.svg';
import Layers_2 from 'assets/icons/layers3.svg';
import Cloud from 'assets/icons/cloud.svg';
import Connection from 'assets/icons/connection.svg';
import Phone from 'assets/icons/phone.svg';
import Setting from 'assets/icons/setting.svg';
import Combain from 'assets/icons/combain.svg';
import Star from 'assets/icons/star.svg';
import Fire from 'assets/icons/fire.svg';
import Case from 'assets/icons/case.svg';

const labels = ['Поддержка приложений', 'ИТ\u2011услуги', 'ИТ\u2011управление'];

const sameStyles = {
  boxSize: 'unset',
  w: 'full',
  maxW: 'full',
  p: { mobile: '20px 20px 20px 76px', tablet: '28px', laptop: '36px' },
  borderRadius: DEFAULT_BORDER_RADIUS,
  justify: { mobile: 'center', xxm: 'end' },
  titleProps: {
    textStyle: { mobile: 'header.h4', laptop: 'h4', desktop: 'header.h4' },
    fontSize: { mobile: '14px', xm: '18px', laptop: '24px', desktop: '26px' },
  },
  iconProps: {
    p: 'unset',
    boxSize: { mobile: '40px', laptop: '72px' },
    top: { mobile: 'calc(50% - (40px / 2))', xxm: '8px', laptop: '12px' },
    left: { mobile: '20px', xxm: '8px', laptop: '12px' },
    imageProps: { boxSize: { mobile: '22px', laptop: '32px' } },
  },
};
const tabsData = {
  [labels[0]]: [
    {
      src: Layers1,
      title: 'Первая линия поддержки',
      ...sameStyles,
      bgColor: 'bg.white',
      border: DEFAULT_BORDER,
      borderColor: 'line.gray',
      iconProps: { bgColor: 'bg.grayLight', ...sameStyles.iconProps },
    },
    { src: Layers2, title: 'Вторая линия поддержки', bgColor: 'bg.gray', ...sameStyles },
    { src: Layers3, title: 'Третья линия поддержки', bgColor: 'bg.neonLight', ...sameStyles },
    { src: Layers4, title: 'Четвертая линия поддержки', bgColor: 'bg.grayLight', ...sameStyles },
    { src: Notes, title: 'Наблюдение', bgColor: 'bg.grayLight', ...sameStyles },
    {
      src: Architer,
      title: 'Администрирование баз данных',
      bgColor: 'bg.neonLight',
      ...sameStyles,
    },
    {
      src: Measuring,
      title: 'Управление мощностями',
      ...sameStyles,
      bgColor: 'bg.white',
      border: DEFAULT_BORDER,
      borderColor: 'line.gray',
      iconProps: { bgColor: 'bg.grayLight', ...sameStyles.iconProps },
    },
    { src: Adding, title: 'Управление учётными записями', bgColor: 'bg.gray', ...sameStyles },
  ],
  [labels[1]]: [
    { src: Layers_2, title: 'Служба поддержки', bgColor: 'bg.grayLight', ...sameStyles },
    { src: Cloud, title: 'Управление облаком', bgColor: 'bg.gray', ...sameStyles },
    {
      src: Connection,
      title: 'Управление сетью',
      ...sameStyles,
      bgColor: 'bg.white',
      border: DEFAULT_BORDER,
      borderColor: 'line.gray',
      iconProps: { bgColor: 'bg.grayLight', ...sameStyles.iconProps },
    },
    { src: Adding, title: 'Управление конфигурациями', bgColor: 'bg.neonLight', ...sameStyles },
    { src: Phone, title: 'Телефония', bgColor: 'bg.neonLight', ...sameStyles },
    {
      src: Setting,
      title: 'Аппаратное управление',
      ...sameStyles,
      bgColor: 'bg.white',
      border: DEFAULT_BORDER,
      borderColor: 'line.gray',
      iconProps: { bgColor: 'bg.grayLight', ...sameStyles.iconProps },
    },
    { src: Combain, title: 'Программное управление', bgColor: 'bg.gray', ...sameStyles },
  ],
  [labels[2]]: [
    { src: Star, title: 'Контроль качества', bgColor: 'bg.neonLight', ...sameStyles },
    { src: Fire, title: 'Управление выпусками', bgColor: 'bg.grayLight', ...sameStyles },
    {
      src: Case,
      title: 'Управление поставщиками',
      ...sameStyles,
      bgColor: 'bg.white',
      border: DEFAULT_BORDER,
      borderColor: 'line.gray',
      iconProps: { bgColor: 'bg.grayLight', ...sameStyles.iconProps },
    },
    { src: Architer, title: 'Контроль архитектуры', bgColor: 'bg.neonLight', ...sameStyles },
  ],
};

export const maintenanceSupportMultiTabsCardsData = {
  CardComponent: ExpertiseCard,
  title: 'Наши услуги',
  labels,
  tabsData,
  gridProps: {
    gridTemplateColumns: { mobile: '1fr', xxm: 'repeat(2, 1fr)', xxl: 'repeat(4, 1fr)' },
    autoRows: { mobile: '80px', xxm: '215px', laptop: '325px' },
  },
  metricNameOnSwitcherClick: 'it-support_selector_click',
};
